require('../javascript/lander.js')
require('../javascript/lander_styles.js')

require('../../../lib/packages/yggdrasil-blueprints/__generated__/blueprints/sharedModules.ts')
